module.exports = __webpack_public_path__ + "static/img/piece_2101.72dd1e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/piece/piece_2101.png
// module id = U/3u
// module chunks = 0